import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="response-schedule"
// Tapping the calendar icon opens the native date picker.
// Picking a date auto-submits the form.
export default class extends Controller {
  static targets = ["input", "form"]

  openPicker() {
    if (this.hasInputTarget) {
      this.inputTarget.showPicker()
    }
  }

  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
